module.exports = __webpack_public_path__ + "static/media/people-policies.26b24efe.svg";